import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Partners } from '@lockton-apps/shared/interfaces';

@Component({
    selector: 'lui-partner-logo',
    imports: [CommonModule],
    templateUrl: './partner-logo.component.html',
    styleUrls: ['./partner-logo.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PartnerLogoComponent {
  @Input() partner!: number | undefined;
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  get sizeClass() {
    return `partner-logo--${this.size}`;
  }

  partners = Partners;
}
